// NineNative resolver — iframe / inner mode 양립을 위한 indirection.
//
// iframe 모드: viewer 의 own contentWindow 에 host 가 `NineNative` 를 직접 주입 →
// default getter 가 `(window as any).NineNative` 를 반환.
//
// inner 모드: host 가 마운트 시점에 `setNineNative(getter)` 로 자신의 NineNative
// instance 를 반환하는 getter 를 등록 → resolver 가 그 getter 결과를 반환.

// 네이티브 브릿지 계약의 단일 출처는 common-web(components/viewer/NineNativeApi)이다. 기존
// `./nineNative` 의 `NineNativeAPI` import 경로를 유지하기 위해 별칭으로 재노출한다.
import type { NineNativeApi } from 'components/viewer'

export type { NineNativeApi }
export type NineNativeAPI = NineNativeApi

type NineNativeGetter = () => NineNativeAPI | undefined

const defaultGetter: NineNativeGetter = () =>
  (window as unknown as { NineNative?: NineNativeAPI }).NineNative

let resolver: NineNativeGetter = defaultGetter

export function setNineNative(getter: NineNativeGetter): void {
  resolver = getter
}

export function resolveNineNative(): NineNativeAPI | undefined {
  return resolver()
}

export function resetNineNative(): void {
  resolver = defaultGetter
}
